import { ViewType } from '../types/IHealthCheck';

import { localStorageKeys } from '@/utils/tokens';
import { devError } from '@/utils/logging';

export const LANDING_VIEWS: ViewType[] = ['fleet', 'dispatcher', 'depot'];

export const DEFAULT_LANDING_VIEW: ViewType = 'fleet';

/**
 * Stored as a bare string rather than JSON, so anything unrecognised - a value
 * left over from an older build, a hand-edited entry - simply fails the check
 * and falls back to Fleet instead of throwing.
 */
export const loadLandingView = (): ViewType => {
  try {
    const saved = localStorage.getItem(localStorageKeys.healthCheckLandingView);

    return LANDING_VIEWS.includes(saved as ViewType)
      ? (saved as ViewType)
      : DEFAULT_LANDING_VIEW;
  } catch (error) {
    devError('Failed to load landing view from localStorage:', error);
    return DEFAULT_LANDING_VIEW;
  }
};

export const saveLandingView = (view: ViewType) => {
  try {
    localStorage.setItem(localStorageKeys.healthCheckLandingView, view);
  } catch (error) {
    devError('Failed to save landing view to localStorage:', error);
  }
};

export const loadLayoutColumns = (): 2 | 3 => {
  try {
    const saved = localStorage.getItem(localStorageKeys.layoutColumns);
    return saved ? JSON.parse(saved) : 2;
  } catch (error) {
    devError('Failed to load layout columns from localStorage:', error);
    return 2;
  }
};

export const saveLayoutColumns = (columns: 2 | 3) => {
  try {
    localStorage.setItem(
      localStorageKeys.layoutColumns,
      JSON.stringify(columns)
    );
  } catch (error) {
    devError('Failed to save layout columns to localStorage:', error);
  }
};
